export default class DashboardTrendDefinition {
    constructor(id, column, localizedLabel, greenTrendOnPositiveData) {
        this._id = id;
        this._column = column;
        this._localizedLabel = localizedLabel;
        this._greenTrendOnPositiveData = greenTrendOnPositiveData;
    }

    get id() {
        return this._id;
    }

    get column() {
        return this._column;
    }

    get localizedLabel() {
        return this._localizedLabel;
    }

    get greenTrendOnPositiveData() {
        return this._greenTrendOnPositiveData;
    }
}
